import type { WeekDoc, WeekStatus } from "@/lib/types";

interface WeekSelectProps {
  weeks: WeekDoc[];
  value: string;
  onChange: (weekId: string) => void;
}

const STATUS_HINT: Record<WeekStatus, string> = {
  open: "Mở",
  approved: "Đã duyệt",
  paid: "Đã chốt",
};

export function WeekSelect({ weeks, value, onChange }: WeekSelectProps) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="rounded-full border border-pink-100 bg-white px-3 py-1.5 text-sm font-semibold text-gray-700 shadow-sm focus:border-pink-300 focus:outline-none focus:ring-2 focus:ring-pink-100"
    >
      {weeks.map((week) => (
        <option key={week.startDate} value={week.startDate}>
          Tuần {week.label} • {STATUS_HINT[week.status]}
        </option>
      ))}
    </select>
  );
}
